import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBigquery = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.415 88.751L2.418 54.113a8.76 8.76 0 010-8.76l19.997-34.637a8.76 8.76 0 017.588-4.38h39.995a8.76 8.76 0 017.587 4.38l19.998 34.637a8.76 8.76 0 010 8.76L77.585 88.752a8.76 8.76 0 01-7.587 4.38H30.003a8.76 8.76 0 01-7.588-4.38z",
			fill: "url(#prefix__paint0_linear_2906_41683)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .07,
			d: "M92.074 66.859l-29.409-29.41L50 34.058l-11.376 4.228-4.394 11.446 3.533 12.745L68.95 93.665l6.618-.294 16.506-26.512z",
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50 32.063c-9.758 0-17.67 7.91-17.67 17.67 0 9.76 7.912 17.67 17.67 17.67 9.76 0 17.67-7.91 17.67-17.67 0-9.76-7.912-17.67-17.67-17.67zm0 31.078c-7.404 0-13.408-6.003-13.408-13.408 0-7.405 6.004-13.407 13.408-13.407 7.405 0 13.408 6.003 13.408 13.407 0 7.405-6.003 13.408-13.408 13.408",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.612 49.051v5.493a9.747 9.747 0 003.337 3.409V49.05h-3.337zm6.617-4.63v14.787a9.615 9.615 0 001.744.168c.544 0 1.074-.057 1.595-.144V44.42h-3.34zm6.925 6.912v6.523a9.741 9.741 0 003.339-3.58v-2.942h-3.339zm7.561 9.285l-1.83 1.832a.829.829 0 000 1.17l6.944 6.942a.829.829 0 001.17 0l1.831-1.83a.832.832 0 000-1.17l-6.945-6.944a.83.83 0 00-1.17 0z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "prefix__paint0_linear_2906_41683",
			x1: 50.001,
			y1: 6.336,
			x2: 50.001,
			y2: 92.996,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4387FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4683EA"
			})]
		}) })
	]
});
export default SvgBigquery;
